import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

import {parse} from '@atmi/core/utils';

import {filter, map} from 'rxjs/operators';

import {SwalService} from '@atmi/core'; // TODO: Avoid external dependencies not related to Angular

import {BaseTableComponent} from '../table/base-table.component';
import {TableFilterType} from '../table/table';
import {
  extractFilterObjectFromParams,
  FilterFieldsOptions,
  makeQueryBuilder,
  makeQueryRules,
  QueryBuilder
} from './filters';

export abstract class BaseTableFilteredComponent<T extends { id?: string }, Z> extends BaseTableComponent<T> {

  readonly filtersObj$ = this.route.queryParams.pipe(
    map((params) => params.q),
    filter((q): q is string => !!q),
    map((q) => parse<QueryBuilder<Z>>(q)),
    map((q) => {
      return q.rules;
    }),
    map((filters) => extractFilterObjectFromParams(filters, this.filterMeta)),
  );

  readonly filters$ = this.route.queryParams.pipe(
    map((params) => {
      return params.q
    }),
    filter((q): q is string => !!q),
    map((q) => parse<TableFilterType>(q)),
  );

  constructor(
    protected readonly translate: TranslateService,
    protected readonly router: Router,
    protected readonly route: ActivatedRoute,
    protected readonly filterMeta: FilterFieldsOptions<Z>,
    protected readonly swalService: SwalService,
    managerPath?: string,
    protected readonly paginationStore: 'route' | 'local' | 'none' = 'route',
  ) {
    super(translate, router, route, swalService, managerPath, paginationStore);
  }

  applyFilterWithDelayHandler(filters: Z) {
    const rules = makeQueryRules(filters, this.filterMeta);
    const query = makeQueryBuilder(rules);
    const q = JSON.stringify(query);
    const queryParams = {q};

    this.selectedItems = [];
    this.router.navigate(['./'], {relativeTo: this.route, queryParamsHandling: 'merge', queryParams});
  }
}
